import { createContext } from 'react';

import { initialActionsState } from './actions';
import { initialState } from './reducer';
import * as initialSelectors from './selectors';
import type { IEnvCropsProductsContextValue } from './types';

export default createContext<IEnvCropsProductsContextValue>({
  state: initialState,
  actions: initialActionsState,
  selectors: initialSelectors,
});
